import React from 'react';
import './privacyPolicySection.scss';
import NumberedComponent from "../../../termsConditions/sections/termsConditionSection/components/NumberedComponent";

const PrivacyPolicySection = () => {
	return (
		<div className="privacyPolicySection">
			<div className="privacyPolicySection__content">
				<div className="privacyPolicySection__content_start">
					<h1>Privacy Policy</h1>
					<span>
						Welcome to [Your Website Name] ("we," "our," "us"). We are committed to protecting your privacy
						and ensuring that your personal information is handled in a safe and responsible manner.
						This Privacy Policy outlines how we collect, use, and protect your information when you
						visit our website [Your Website URL] (the "Site").<br/><br/>
						By using our Site, you agree to the collection and use of information in accordance with this policy.
					</span>
				</div>
				<div className="privacyPolicySection__content_list">
					<NumberedComponent
						index={'1'}
						title={'Information We Collect'}
						description={'We may collect the following types of information:'}
						list={[
							'Personal Information: When you register on our Site, place an order, subscribe to our newsletter, or fill out a form, we may collect personal information such as your name, email address, mailing address, phone number, and payment information.',
							'Non-Personal Information: We may collect non-personal information such as browser type, operating system, IP address, and browsing behavior to improve our Site and services.',
							'Cookies: We use cookies to enhance your experience on our Site. Cookies are small files stored on your device that help us analyze web traffic and remember your preferences. You can choose to accept or decline cookies through your browser settings.'
						]}
					/>
					
					<NumberedComponent
						index={'2'}
						title={'How We Use Your Information'}
						description={'We use the information we collect for the following purposes:'}
						list={[
							'To process and fulfill your orders.',
							'To send you promotional materials, newsletters, and updates (you can opt-out at any time).',
							'To improve our Site, products, and services.',
							'To respond to your inquiries and provide customer support.',
							'To detect and prevent fraud and other illegal activities.'
						]}
					/>
					
					<NumberedComponent
						index={'3'}
						title={'Sharing Your Information'}
						description={'We do not sell, trade, or otherwise transfer your personal information to outside parties except in the following circumstances:'}
						list={[
							'Service Providers: We may share your information with trusted third-party service providers who assist us in operating our Site, conducting our business, or servicing you, as long as they agree to keep this information confidential.',
							'Legal Requirements: We may disclose your information if required to do so by law or in response to valid requests by public authorities.',
							'Business Transfers: In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred to the new owner.'
						]}
					/>
					
					<NumberedComponent
						index={'4'}
						title={'Data Security'}
						description={'We implement a variety of security measures to maintain the safety of your personal information. These measures include encryption, secure socket layer (SSL) technology, and regular malware scanning. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.'}
					/>
					
					<NumberedComponent
						index={'5'}
						title={'Your Rights'}
						description={'Depending on your location, you may have the following rights regarding your personal information:'}
						list={[
							'Access: You can request a copy of the personal information we hold about you.',
							'Correction: You can request that we correct any inaccurate or incomplete information.',
							'Deletion: You can request that we delete your personal information, subject to certain exceptions.',
							'Opt-Out: You can opt-out of receiving promotional communications from us by following the unsubscribe link in our emails or contacting us directly.'
						]}
						secondDescription={'To exercise any of these rights, please contact us at [Your Contact Information].'}
					/>
					
					<NumberedComponent
						index={'6'}
						title={'Third-Party Links'}
						description={'Our Site may contain links to third-party websites. These sites have their own privacy policies, and we are not responsible for their content or activities. We encourage you to review the privacy policies of any third-party sites you visit.'}
					/>
					
					<NumberedComponent
						index={'7'}
						title={'Children\'s Privacy'}
						description={'Our Site is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.'}
					/>
					
					<NumberedComponent
						index={'8'}
						title={'Changes to This Privacy Policy'}
						description={'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy periodically to stay informed about how we are protecting your information.'}
					/>
				</div>
			</div>
		</div>
	);
};

export default PrivacyPolicySection;